import { create } from 'zustand';

export const useAccountContextSheetStore = create<{
  hide: () => void;
  isOpen: boolean;
  show: () => void;
}>((set) => ({
  isOpen: false,
  show: () => set({ isOpen: true }),
  hide: () => set({ isOpen: false }),
}));

export function showAccountContextSheet() {
  useAccountContextSheetStore.getState().show();
}

export function hideAccountContextSheet() {
  useAccountContextSheetStore.getState().hide();
}
